.dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
  vertical-align: middle;
}

.dot {
  display: inline-grid;
  place-items: center;
  width: 12px;
  height: 12px;
  border: 1.5px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--on-fill);
}

.met {
  border-color: var(--accent);
  background: var(--accent);
}

.broken {
  border-color: var(--crit);
  background: var(--crit);
}

/* A met or broken link is told from an open one by its fill; forced colours turns every fill to Canvas
   and would leave three identical rings (G-P10-20). The dot is a box with a glyph, so it keeps its colour. */
@media (forced-colors: active) {
  .met,
  .broken {
    forced-color-adjust: none;
  }
}
